@if (showLoading) {
    <app-brands-loader [showBrandLoaderHeader]="!isEatClubApp"></app-brands-loader>
} @else {
    <div [ngClass]="outletBanners['main_promotional_card']?.length ? 'moveUpwards' : ''">
        <app-home-page-banners [outletBanners]="outletBanners" [isMobile]="isMobile" />
        @if (lottieUrl) {
            <dotlottie-player autoplay="true" loop="true" class="container animated-banner" src="{{ lottieUrl }}" />
        }

        <app-shop-by-membership [memberships]="memberships" [isMobile]="isMobile" />
        <app-shop-by-category
            [memberships]="memberships"
            [isMobile]="isMobile"
            [isBrandRating]="isBrandRating"
            [showMenuFirst]="showMenuFirst" />

        @if (isBrandRating && landingPageBanners['mweb_offer']) {
            <app-brand-news [isRepeatUser]="showMenuFirst" [banners]="landingPageBanners['mweb_offer']" />
        }
        @if (isBrowser) {
            <app-birthday-animation />
        }
        @if (isBrowser && isMobile) {
            <app-bottom-navigation />
        }
        @if (showBottomStrips) {
            <app-bottom-strip-carousel [bottomStrips]="bottomStrips" (showFeedback)="showFeedback($event)" />
        }
        @if (showOutletStatusStrip) {
            <outlet-status-strip />
        }
    </div>
}
